import { useContext } from 'react'
import { QuestionAnswerOutlined } from '@mui/icons-material'
import { Fab } from '@mui/material'

import { ChatContext } from '../../providers/chat-provider'
import useIsMobile from '../../utils/hooks/useIsMobile'

import classes from './index.styles'

// Lets users return to an active 8x8 session; the open chat window renders above this button.
const ChatFab = () => {
  const isMobile = useIsMobile()
  const { chatActive, startChat } = useContext(ChatContext)

  if (!chatActive) return null

  return (
    <Fab color="primary" variant={isMobile ? 'circular' : 'extended'} aria-label="Open chat" onClick={startChat} sx={(theme) => classes.fab(theme, isMobile)}>
      <QuestionAnswerOutlined sx={classes.icon(isMobile)} />
      {!isMobile && 'Chat'}
    </Fab>
  )
}

export default ChatFab
